module.exports = __webpack_public_path__ + "static/media/details-26-image-2.eabf76d6.jpg";